import React from 'react';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const FilterModal = ({ isOpen, onClose, filters, activeFilters, onFilterChange, onApplyFilters, onClearFilters }) => {
  if (!isOpen) return null;

  const hasActiveFilters = Object.values(activeFilters)?.some(Boolean);

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl max-h-[80vh] overflow-hidden shadow-2xl">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <h3 className="text-base font-semibold text-gray-900">Filters</h3>
          <div className="flex items-center gap-2">
            {hasActiveFilters && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onClearFilters}
                className="text-gray-500 hover:text-gray-900 text-xs font-medium"
              >
                Clear All
              </Button>
            )}
            <Button variant="ghost" size="icon" onClick={onClose} iconName="X" className="text-gray-700" />
          </div>
        </div>

        <div className="overflow-y-auto max-h-[60vh] p-4">
          <div className="space-y-6">
            {filters?.map((filterGroup, idx) => (
              <div key={filterGroup?.key} className={idx > 0 ? 'pt-5 border-t border-gray-100' : ''}>
                <h4 className="text-sm font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <Icon name={filterGroup?.icon} size={15} className="text-gray-400" />
                  {filterGroup?.label}
                </h4>
                <div className="space-y-2.5">
                  {filterGroup?.options?.map((option) => {
                    const checked = activeFilters?.[`${filterGroup?.key}_${option?.value}`] || false;
                    return (
                      <label key={option?.value} className="flex items-center justify-between cursor-pointer">
                        <span className="flex items-center gap-2.5">
                          <Checkbox
                            checked={checked}
                            onChange={(e) => onFilterChange(`${filterGroup?.key}_${option?.value}`, e?.target?.checked)}
                          />
                          <span className={`text-sm ${checked ? 'text-gray-900 font-medium' : 'text-gray-700'}`}>
                            {option?.label}
                          </span>
                        </span>
                        <span className="text-xs text-gray-400 font-medium tabular-nums">{option?.count}</span>
                      </label>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="p-4 border-t border-gray-100">
          <Button variant="default" fullWidth onClick={onApplyFilters}>
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterModal;